<template>
  <div id="hldResult">
    <div class="title">
      霍兰德高考志愿倾向测试结果报告
    </div>
    <div v-if="this.report">
      <div id="tabs-1">
        <div class="pctitle">
          介绍</div>
        <div class="career-number" v-html="this.report.selfImprovement">
        </div>
      </div>
      <div id="tabs-1">
        <div class="pctitle">
          意义</div>
        <div class="career-number" v-html="this.report.significance">
        </div>
      </div>
      <div id="tabs-1">
        <div class="pctitle">
          你的霍兰德代码</div>
        <div class="career-number">{{ this.report.appraise }}
        </div>
        <div id="main"></div>
      </div>

      <div id="tabs-1">
        <div class="pctitle">
          霍兰德代码的特点</div>
        <div class="career-number">{{ this.report.feature }}
        </div>
      </div>

      <div id="tabs-1">
        <div class="pctitle">
          推荐的专业</div>
        <div class="career-number" v-html="this.report.referenceMajor">
        </div>

      </div>



    </div>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {
      report: {

      },
    };
  },
  computed: {
  },
  created() {
    this.getData()

  },
  mounted() {

  },
  methods: {
    getData() {
      this.$fecth
        .post("ceping/get_hld_report_info", {
          id: this.$route.query.id
        })
        .then((res) => {
          this.report = JSON.parse(res.report)
          console.log(this.report)
          this.createEcharts();
        });
    },
    createEcharts() {
      let echarts = require("echarts");
      let myChart = echarts.init(document.getElementById("main"));
      let numList = [];
      let titleLIst = [];
      this.report.myScoreArr.forEach(element => {
        console.log(element)
        let test = {
          name: element['类型'] + element['评价'],
          max: 100
        }
        titleLIst.push(test)

        numList.push(element['得分'])

      });

      console.log(numList)
      let option = {
        radar: {
          // shape: 'circle',
          indicator: titleLIst
        },
        label: {
          show: true,
          formatter: function (params) {
            return params.value;
          }
        },
        series: [
          {
            name: 'Budget vs spending',
            type: 'radar',
            data: [
              {
                value: numList,
                name: 'Allocated Budget'
              },
            ]
          }
        ]
      };
      myChart.setOption(option);
    },
  },
};
</script>

<style scoped lang='less'>

.title {
  text-align: center;
  margin-top: 30px;
  background: #4870f6;
  color: white;
  padding: 16px 0;
  font-size: 30px;
}

#main {
  width: 100%;
  margin-bottom: 30px;
  padding-bottom: 40px;
  min-height: 300px;
}

#hldResult {
  width: 1200px;
  margin: 20px auto 20px;

}

#tabs-1 {
  box-shadow: 0px 0px 5px #dddddd;
  margin-bottom: 30px;

  // text-indent: 25px;
}

.pctitle {
  line-height: 50px;
  height: 50px;
  padding: 0 30px;
  color: black;
  border-bottom: 2px solid #4870f6;
  margin-bottom: 20px;
  // background: #4870f6;

}

.career-number {
  padding: 0 30px;
  line-height: 50px;
  font-size: 24px;
  margin: 0;
  padding-bottom: .12em;
}

</style>
